<template>
  <div class="arrow-btn-container">
    <slot>

    </slot>
  </div>
</template>

<script>
export default {
  name: "container"
}
</script>

<style scoped>
.arrow-btn-container {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
